import { Form, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import * as Apis from "../../utils/helper/enum";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";

const ReassignDriver = ({ isOpen, onOk, onCancel, orderId }) => {
  const dispatch = useDispatch();

  const [driverList, setDriverList] = useState([]);
  const [driverId, setDriverId] = useState(0);
  const [driverSloteId, setDriverSloteId] = useState(0);

  const selectDriver = async (driverId) => {
    setDriverId(driverId);
    for (let item of driverList) {
      if (item.value === driverId) setDriverSloteId(item.driverSloteId);
    }
  };

  const getAllDriver = async () => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_DRIVER + "/" + orderId,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (apiResponse.data) {
          let loadData = [];
          for (let item of apiResponse?.data) {
            loadData.push({
              value: item.id,
              label:
                item.firstName + " " + item.lastName + " | " + item.mobileNo,
              driverSloteId: item?.driverDetail?.driverWorkingHours
                ? item?.driverDetail?.driverWorkingHours[0]?.id
                : 0,
            });
          }
          setDriverList(loadData);
        } else {
          setDriverList([]);
        }
        // setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllDriver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  return (
    <>
      <Modal
        title="Reassign Driver"
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={() => {
          onOk(driverId, driverSloteId);
        }}
        okText="Yes"
        cancelText="No"
        okButtonProps={{ disabled: driverId <= 0 }}
      >
        <p className="text-sm">Are you sure want to reassign the Driver?</p>
        <Form
          name="Reassign Driver"
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          <Form.Item
            label="Choose Driver"
            name="Choose Driver"
            rules={[
              {
                required: true,
                message: "Please enter your Choose Driver",
              },
            ]}
          >
            <Select
              size="large"
              placeholder="Select"
              options={driverList}
              showSearch
              filterOption={(input, driverList) =>
                (driverList?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onChange={(e) => {
                selectDriver(e);
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default ReassignDriver;
